import React from 'react';
import PropTypes from 'prop-types';

// Style
import MarginStyle from './Styled';

const Margin = ({ left, top, right, bottom }) => (
  <MarginStyle theme={{ left, top, right, bottom }} />
);

Margin.defaultProps = {
  left: 1,
  top: 1,
  right: 1,
  bottom: 1,
};

Margin.prototypes = {
  left: PropTypes.number,
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
};

export default Margin;
export { Margin };
